import { c as _c } from "react/compiler-runtime";
// Общая основа иконок макета: размер пропсом, цвет через currentColor,
// по умолчанию скрыта от экранных чтецов (подпись — у кнопки вокруг).
import type { SVGProps } from "react";
export type IconProps = {
  /** Ширина в px; высота считается по пропорции рисунка (у квадратных — та же). */
  size?: number;
  className?: string;
  /** Толщина обводки — только у контурных иконок (stroke); у залитых не влияет. */
  strokeWidth?: number;
} & SVGProps<SVGSVGElement>;
export function Svg(t0) {
  const $ = _c(11);
  let children;
  let props;
  let size;
  let t1;
  if ($[0] !== t0) {
    ({
      size,
      ratio: t1,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = size;
    $[4] = t1;
  } else {
    children = $[1];
    props = $[2];
    size = $[3];
    t1 = $[4];
  }
  const ratio = t1 === undefined ? 1 : t1;
  const labelled = props["aria-label"] != null || props["aria-labelledby"] != null;
  const t2 = Math.round(size * ratio * 100) / 100;
  const t3 = labelled ? undefined : true;
  let t4;
  if ($[5] !== children || $[6] !== props || $[7] !== size || $[8] !== t2 || $[9] !== t3) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" width={size} height={t2} fill="none" aria-hidden={t3} focusable="false" {...props}>{children}</svg>;
    $[5] = children;
    $[6] = props;
    $[7] = size;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}